import React from "react";
import { Div, P, Input } from "glamorous";
import styles from "../../../styles";

const fonts = [
  { name: "Arvil", value: "Arvil Sans" },
  { name: "Bender", value: "Bender Inline" },
  { name: "Blanch", value: "Blanch Condensed" },
  { name: "Cubano", value: "Cubano" },
  { name: "Gotham", value: "Gotham Book" },
  { name: "JW Book", value: "JWSansBook" },
  { name: "Mensch", value: "Mensch" },
  { name: "Muncie", value: "Muncie" },
  { name: "Sabon", value: "Sabon LT Std" },
  { name: "Sullivan", value: "Sullivan" },
  { name: "Tommaso", value: "Tommaso" },
  { name: "Valencia", value: "Valencia" },
  { name: "Vevey", value: "Vevey" }  
];

const previewText = "Ag";

export default ({ fontSize, fontFamily, setFontFamily, setFontSize }) => (
  <Div css={styles.text.customiseOptions}>
    {fonts.map((font, index) => (
      <Div
        css={font.value === fontFamily ? styles.text.fontOptionSelected : styles.text.fontOption}
        key={`font_${index}`}
        onClick={() => setFontFamily(font.value)}
      >
        <Div css={styles.text.fontFamilyWrapper}>
          <P style={{ fontFamily: font.value }} css={styles.text.familyPreview}>
            {previewText}
          </P>
          <P css={styles.text.familyTitle}>{font.name}</P>
        </Div>
      </Div>
    ))}
    <Div css={styles.text.fontSliderWrapper}>
      <Input
        type="range"
        min="14"
        max="72"
        step="1"
        value={fontSize}
        css={styles.editor.slider}
        onChange={evt => setFontSize(evt.currentTarget.value)}
      />
    </Div>
  </Div>
);



// WEBPACK FOOTER //
// ./src/components/areas/EditorText/Font.js